import { network } from 'services/network';

export const setDashboard = (params) => {
    return network.post('api/bo/setDashboard', params).then((response) => {
        return response.data;
    });
};
